import React, { useEffect, useRef, useState } from 'react';
import { Collapse, Button } from 'react-bootstrap';
import { requestCanceller } from '../../../service/axiosCancelToken';
import { getTodayViewers } from '../../../service/viewerService';
import LoadingSpinner from '../../shared/LoadingSpinner';
import DeviceInfo from './DeviceInfo';

const Today = () => {
	const [viewers, setViewers] = useState();
	const timeRef = useRef(null);
	const viewersRef = useRef(null);
	const onlineCounterRef = useRef(0);
	const [showTodayCollapse, setShowTodayCollapse] = useState(false);



	useEffect(() => {
        const cancelRequest = requestCanceller();

		const fetchViewers = async () => {
			try {
				const { status, data } = await getTodayViewers({cancelToken: cancelRequest.signal});
				if (status === 201) {
					viewersRef.current = data.viewers;
					viewersRef.current.forEach(element => {
						if(element.isOnline)
						++onlineCounterRef.current;

					});
					timeRef.current = new Date();
					setViewers(data.viewers.reverse());
				}
			} catch (err) {

			}

		}

		fetchViewers();

		return () => {
			cancelRequest.cancel();
		}
	},[])

	return (
		<React.Fragment>
			{
				!viewers ?
				<div style={{ height: '55vh' }} className="d-flex">
					<div className="text-center align-self-center mx-auto">
						<LoadingSpinner />
					</div>
				</div> 
				:
				<div className="background_today_view">
					<div className="background_myank col-12 pt-4 pb-1 px-0 mt-3 border rounded-sm">
						<div className="col-12 justify-content-between d-flex">
							<h5 className="text-dark  h5 float-right">
								امروز  :
						</h5>
							<h5 className="align-self-end">
								<label htmlFor="" className="badge badge-success badge-pill mx-2 float-left ">{viewers.length - onlineCounterRef.current}</label>
							</h5>
						</div>
						<div className="d-flex text-center">
							<Button
								variant="success"
								onClick={() => setShowTodayCollapse(!showTodayCollapse)}
								aria-controls="example-collapse-text"
								aria-expanded={showTodayCollapse}
								className="rounded-pill  mx-auto"
								size="sm"
							>
								<i className={showTodayCollapse ? "fa fa-arrow-up" : "fa fa-arrow-down"}></i>
							</Button>
						</div>
						<Collapse in={showTodayCollapse}>
							<div id="example-collapse-text" className="text-dark  px-2" style={{ direction: 'ltr' }}>
								{
									viewers.map(viewer => (
										!viewer.isOnline &&
										(
											<DeviceInfo
												key={viewer._id}
												device={viewer.device}
												client={viewer.client}
												ip={viewer.ip}
												city={viewer.city}
												country={viewer.country}
												os={viewer.os}
												pageVisit={viewer.pageVisit}
												isBot={viewer.isBot}
											/>
										)
									))
								}
							</div>
						</Collapse>
					</div>
				</div>
				
			}
		</React.Fragment>
	);
}

export default Today;